import { CSSProperties } from "react";
import Properties from "src/assets/data/css-properties.json";

export function CSSObjectToString( css: CSSProperties, isImportant: boolean = false ): string {
    let string = '' 
    const important = isImportant ? "!important": ""
    Object.keys( css ).forEach((key: any ) => {
        const _key: keyof CSSProperties = key
        const value     = typeof css[_key] === "string" ? css[_key] : getCSSValue( key, css[_key] )
        const cssKey    = camelToKebabCase(key)
        if(_key !== "content") {
            string += `${cssKey}:${value}${important}; `
        }
    })
    return string
}

export const camelToKebabCase = (str: string): string => str.replace(/[A-Z]/g, letter => `-${letter.toLowerCase()}`)

export const getCSSValue = (_key: string, value: number| any ): any => {
    const isLength = !!(Properties.find( (css: any) => css.property === _key )?.values?.find(val => val === "length"))?.length
    if( isLength && typeof value === "number") {
        value = `${value}px`
    }
    return value
}